import MentoringOldWomanIcon from './MentoringOldWomanIcon.vue';

export default MentoringOldWomanIcon;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/oldwoman/index.ts